import React from 'react';
import PropTypes from 'prop-types';
import GlyphedButton from '../base/Button/GlyphedButton';
import {ADD_GLYPH} from '../../const/Glyphicons';
import componentTexts from './translate.json';
import './PostComplaintIssueWindow.scss';

function PostComplaintIssueWindow({email, onbtnNewComplaintWithCustomerDataClick})  {
    return(
        <div className="col-xs-12" style={{fontSize: "16px", fontFamily: "Calibri", fontWeight: "bold", textAlign: "center"}}>
            <p id="title">{componentTexts.title}</p>
            <div className="col-xs-12 main-description">
                <p id="description" className="description"> {componentTexts.description}z&nbsp;<u>{componentTexts.description2}</u>&nbsp;oraz&nbsp;<u>{componentTexts.description3}</u>&nbsp;{componentTexts.description4}</p>
                <p id="additional-description" className="description">{componentTexts.additionalEmailDescription} <strong>{email}</strong></p>
            </div>
            <div className="new-complaint-with-filled-customer col-xs-12">
                {/* <div className="col-xs-12">
                    <p id="no-action">{componentTexts.noAction}</p>
                </div> */}
                <div className="col-xs-12">
                    <p id="new-complaint-with-filled-data">{componentTexts.greatings}</p> 
                    <div className="col-xs-12" style={{textAlign: "left"}}>
                        <GlyphedButton
                            htmlId="new-complaint-with-customer-data"
                            glyph={ADD_GLYPH}
                            name="btnNewComplaintWithCustomerData"
                            onClick={onbtnNewComplaintWithCustomerDataClick}
                            title={componentTexts.newComplaint}
                            type="button"
                            label={componentTexts.newComplaint}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

PostComplaintIssueWindow.propTypes = {
    email: PropTypes.string,
    onbtnNewComplaintWithCustomerDataClick: PropTypes.func
};

export default PostComplaintIssueWindow;


// WEBPACK FOOTER //
// ./src/components/PostComplaintIssueWindow/PostComplaintIssueWindow.js